// CS:S-style number menus (like SourceMod menus): a list at the left of the screen, 1-7 pick an
// option, 8 / 9 go back and forward between pages, 0 closes. Used by the chat commands.

export interface MenuItem {
  label: string;
  /** Shown greyed out and can't be picked. */
  disabled?: boolean;
  /** Marked as the current choice. */
  current?: boolean;
  onPick?: () => void;
}

const PER_PAGE = 7;

export class RadioMenu {
  private readonly root = document.createElement('div');
  private title = '';
  private items: MenuItem[] = [];
  private page = 0;

  constructor(parent: HTMLElement) {
    this.root.className = 'radioMenu';
    this.root.hidden = true;
    parent.append(this.root);
  }

  get isOpen() {
    return !this.root.hidden;
  }

  show(title: string, items: MenuItem[], page = 0) {
    this.title = title;
    this.items = items;
    this.page = page;
    this.render();
    this.root.hidden = false;
  }

  close() {
    this.root.hidden = true;
  }

  private get pages() {
    return Math.max(1, Math.ceil(this.items.length / PER_PAGE));
  }

  /** A number key while the menu is open: true if it was used. */
  digit(n: number): boolean {
    if (!this.isOpen) return false;
    if (n === 0) {
      this.close();
      return true;
    }
    if (n === 8 && this.page > 0) {
      this.page--;
      this.render();
      return true;
    }
    if (n === 9 && this.page < this.pages - 1) {
      this.page++;
      this.render();
      return true;
    }
    const item = n >= 1 && n <= PER_PAGE ? this.items[this.page * PER_PAGE + n - 1] : undefined;
    if (!item || item.disabled) return true;
    this.close();
    item.onPick?.();
    return true;
  }

  private render() {
    const r = this.root;
    r.textContent = '';
    const head = document.createElement('div');
    head.className = 'radioTitle';
    head.textContent = this.title;
    r.append(head);
    const start = this.page * PER_PAGE;
    this.items.slice(start, start + PER_PAGE).forEach((it, i) => {
      const row = document.createElement('div');
      row.className = 'radioItem' + (it.disabled ? ' disabled' : '') + (it.current ? ' current' : '');
      const num = document.createElement('b');
      num.textContent = `${i + 1}.`;
      row.append(num, ' ' + it.label + (it.current ? '  ✓' : ''));
      r.append(row);
    });
    r.append(document.createElement('br'));
    const nav = (n: number, label: string, on: boolean) => {
      const row = document.createElement('div');
      row.className = 'radioItem' + (on ? '' : ' disabled');
      const num = document.createElement('b');
      num.textContent = `${n}.`;
      row.append(num, ' ' + label);
      r.append(row);
    };
    if (this.pages > 1) {
      nav(8, 'Back', this.page > 0);
      nav(9, 'More', this.page < this.pages - 1);
    }
    nav(0, 'Exit', true);
  }
}
